import axios from 'axios';
import { API_URL } from '@/config';

export default {

  login(userForm) {
    return axios.post(`${API_URL}/login`, userForm);
  },

  logout() {
    return axios.post(`${API_URL}/logout`);
  },

  me() {
    return axios.get(`${API_URL}/me`);
  },

  passwordReset(data) {
    return axios.post(`${API_URL}/password-reset`, data);
  },

  passwordResetCheck(data) {
    return axios.post(`${API_URL}/password-reset-check`, data);
  },

  passwordResetConfirm(data) {
    return axios.post(`${API_URL}/password-reset-confirm`, data);
  },

  passwordChange(data) {
    return axios.post(`${API_URL}/password-change`, data);
  },

  checkMfa(data) {
    return axios.post(`${API_URL}/check-mfa-code`, data);
  },

  sendMfa(data) {
    return axios.post(`${API_URL}/send-mfa-code`, data);
  }

};
